(function () {
  function init(root) {
    if (!root || root.dataset.cmbtMegaReady === 'true') return;
    root.dataset.cmbtMegaReady = 'true';

    var items = [].slice.call(root.querySelectorAll('.cmbt-nav-item[data-menu]'));
    var scrim = root.querySelector('[data-cmbt-scrim]');
    var drawer = root.querySelector('[data-cmbt-drawer]');
    var burger = root.querySelector('[data-cmbt-burger]');
    var dClose = root.querySelector('[data-cmbt-drawer-close]');
    var closeTimer;
    var lastFocus;
    var desktopMega = window.matchMedia('(min-width: 1200px)');

    function setStickyOffset() {
      var wrap = document.getElementById('nav-wrapper');
      var h = wrap ? Math.round(wrap.getBoundingClientRect().height) : 70;
      document.documentElement.style.setProperty('--cmbt-sticky-h', h + 'px');
      if (scrim) scrim.style.top = h + 'px';
    }

    function closeAll() {
      items.forEach(function (it) {
        it.classList.remove('is-open');
        var btn = it.querySelector('.cmbt-nav-link');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
      if (scrim) {
        scrim.classList.remove('is-on');
        scrim.hidden = true;
      }
    }

    function openItem(it) {
      if (!desktopMega.matches) return;
      items.forEach(function (other) {
        if (other !== it) {
          other.classList.remove('is-open');
          var btn = other.querySelector('.cmbt-nav-link');
          if (btn) btn.setAttribute('aria-expanded', 'false');
        }
      });
      it.classList.add('is-open');
      var link = it.querySelector('.cmbt-nav-link');
      if (link) link.setAttribute('aria-expanded', 'true');
      if (scrim) {
        scrim.hidden = false;
        requestAnimationFrame(function () {
          scrim.classList.add('is-on');
        });
      }
    }

    items.forEach(function (it) {
      var btn = it.querySelector('.cmbt-nav-link');
      if (!btn) return;

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (it.classList.contains('is-open') && !it.dataset.viaHover) {
          closeAll();
        } else {
          openItem(it);
          delete it.dataset.viaHover;
        }
      });

      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        it.addEventListener('mouseenter', function () {
          if (!desktopMega.matches) return;
          clearTimeout(closeTimer);
          if (!it.classList.contains('is-open')) it.dataset.viaHover = '1';
          openItem(it);
        });
        it.addEventListener('mouseleave', function () {
          if (!desktopMega.matches) return;
          closeTimer = setTimeout(function () {
            delete it.dataset.viaHover;
            closeAll();
          }, 140);
        });
      }

      it.addEventListener('focusout', function (e) {
        if (!it.contains(e.relatedTarget)) {
          it.classList.remove('is-open');
          btn.setAttribute('aria-expanded', 'false');
          if (!root.querySelector('.cmbt-nav-item.is-open') && scrim) {
            scrim.classList.remove('is-on');
            scrim.hidden = true;
          }
        }
      });
    });

    if (scrim) {
      scrim.addEventListener('mouseenter', function () {
        if (desktopMega.matches) closeAll();
      });
      scrim.addEventListener('click', function () {
        if (desktopMega.matches) closeAll();
        else closeDrawer();
      });
    }

    function showScrim() {
      if (!scrim) return;
      scrim.hidden = false;
      requestAnimationFrame(function () {
        scrim.classList.add('is-on');
      });
    }

    function hideScrim() {
      if (!scrim) return;
      scrim.classList.remove('is-on');
      scrim.hidden = true;
    }

    function openDrawer() {
      if (!drawer || !burger) return;
      lastFocus = document.activeElement;
      drawer.hidden = false;
      requestAnimationFrame(function () {
        drawer.classList.add('is-on');
      });
      burger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('cmbt-drawer-open');
      showScrim();
      if (dClose) dClose.focus();
    }

    function closeDrawer() {
      if (!drawer || !burger) return;
      drawer.classList.remove('is-on');
      burger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('cmbt-drawer-open');
      hideScrim();
      setTimeout(function () {
        drawer.hidden = true;
      }, 260);
      if (lastFocus) lastFocus.focus();
    }

    if (burger) burger.addEventListener('click', openDrawer);
    if (dClose) dClose.addEventListener('click', closeDrawer);

    if (drawer) {
      drawer.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab') return;
        var focusable = drawer.querySelectorAll('a[href], button:not([disabled])');
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      });
    }

    [].forEach.call(root.querySelectorAll('.cmbt-dacc > button'), function (b) {
      b.addEventListener('click', function () {
        var acc = b.parentElement;
        var on = acc.classList.toggle('is-open');
        b.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var openItemEl = root.querySelector('.cmbt-nav-item.is-open');
      if (openItemEl) {
        var link = openItemEl.querySelector('.cmbt-nav-link');
        if (link) link.focus();
        closeAll();
      }
      if (drawer && drawer.classList.contains('is-on')) closeDrawer();
    });

    root.querySelectorAll('[data-cmbt-cart-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        var drawerEl = document.querySelector('drawer-component');
        if (drawerEl && typeof drawerEl.open === 'function') {
          e.preventDefault();
          drawerEl.open();
        }
      });
    });

    function onViewportChange() {
      setStickyOffset();
      if (!desktopMega.matches) {
        closeAll();
      } else {
        closeDrawer();
      }
    }

    setStickyOffset();
    window.addEventListener('resize', onViewportChange);
    if (typeof desktopMega.addEventListener === 'function') {
      desktopMega.addEventListener('change', onViewportChange);
    } else if (typeof desktopMega.addListener === 'function') {
      desktopMega.addListener(onViewportChange);
    }
  }

  function boot() {
    document.querySelectorAll('[data-cmbt-mega-root]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-cmbt-mega-root]');
    if (root) {
      delete root.dataset.cmbtMegaReady;
      init(root);
    }
  });
})();
